import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55dcc466"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tools__row d-flex"
}
const _hoisted_2 = { class: "tools__item__title" }
const _hoisted_3 = { class: "edit__workarea__actions" }
const _hoisted_4 = { class: "edit__workarea__actions mt-4" }

import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useEventBus } from '@vueuse/core';

import { useCommonStore } from '@/store/common';
import { useEditorStore } from '@/store/editor';
import { useServicesStore } from '@/store/services';

import { removeBase64Prefix } from '@/helpers/removeBase64Prefix';

import { IGenerateBackgroundOptions } from '@/store/editor/types';

import AiCard from '@/components/UI/AiCard/AiCard.vue';
import AiButton from '@/components/UI/AiButton/AiButton.vue';
// import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';

import ColorsList from '@/components/common/ColorsList/ColorsList.vue';
import SizesList from '@/components/common/SizesList/SizesList.vue';
// import StyleList from '@/components/pages/Generate/StyleList/StyleList.vue';
import TimeCounter from '@/components/common/TimeCounter/TimeCounter.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductToolsBottom',
  setup(__props) {

const busError = useEventBus<string>('toast-error');

const { t } = useI18n();

const { generateImage } = useServicesStore();
const { generateImageData, aiCanvasRef } = storeToRefs(useEditorStore());
const { imageForActions, imageResult, imagePrev } = storeToRefs(useServicesStore());

const { isMobile } = storeToRefs(useCommonStore());

const buttonDisabled = ref<boolean>(false);
const generationLoading = ref<boolean>(false);

const generateBackgroundHandler = async (): Promise<void> => {
  if (aiCanvasRef.value) {
    aiCanvasRef.value.canvasUpdateData();
    setTimeout(async () => {
      generateImageData.value.loading = true;
      const options: IGenerateBackgroundOptions = {
        customize: {},
        transforms: generateImageData.value.products.map((product: any) => product.transform),
        size: {
          width: generateImageData.value.canvas.width,
          height: generateImageData.value.canvas.height,
        },
      };

      if (generateImageData.value.activeTab === 'theme') {
        if (generateImageData.value.theme !== null) {
          options.customize.themeId = generateImageData.value.theme.id;
        }
        // if (generateImageData.value.color) {
        //   options.customize.styleColor = generateImageData.value.color;
        // }
      } else if (generateImageData.value.activeTab === 'prompt') {
        options.customize.description = generateImageData.value.prompt || '';
        if (generateImageData.value.negativeList && generateImageData.value.negativeList.length) {
          options.customize.negative = generateImageData.value.negativeList.join(', ');
        }
        if (generateImageData.value.color) {
          options.customize.styleColor = generateImageData.value.color;
        }
        if (generateImageData.value.style) {
          options.customize.styleImageId = generateImageData.value.style.id;
        }
      }
      buttonDisabled.value = true;
      if (isMobile.value) {
        // const appElem = document.querySelector('body');
        const productGallery: HTMLElement | null = document.querySelector('.product-gallery');
        if (productGallery) {
          window.scrollTo({ top: productGallery.offsetTop, left: 0, behavior: 'smooth' });
        }
      }
      generationLoading.value = true;
      const images = generateImageData.value.products.map((product: any) => removeBase64Prefix(product.image));
      generateImage({
        action: 'create_background_for_image',
        images,
        params: options,
      })
        .then(async (res) => {
          imagePrev.value = imageForActions.value;
          const bg = await aiCanvasRef.value.getBackground();
          imageForActions.value = bg.enlargedBase64src;
          imageResult.value = `data:image/png;base64,${res.image}`;
        })
        .catch((e) => {
          busError.emit(e?.message || t('common.err-gen'));
        })
        .finally(() => {
          generationLoading.value = false;
          generateImageData.value.loading = false;
        });
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tools", { 'tools--mobile': _unref(isMobile) }])
  }, [
    (_unref(generateImageData).activeTab === 'prompt')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(AiCard, {
            radius: 16,
            class: "tools__item d-flex align-center flex-1-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('common.color')), 1),
              _createVNode(_component_v_spacer),
              _createVNode(ColorsList, {
                modelValue: _unref(generateImageData).color,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(generateImageData).color) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!_unref(isMobile))
      ? (_openBlock(), _createBlock(AiCard, {
          key: 1,
          radius: 16,
          class: "tools__item tools__item--padding-small d-flex align-center"
        }, {
          default: _withCtx(() => [
            _createVNode(SizesList, {
              height: _unref(generateImageData).canvas.height,
              "onUpdate:height": _cache[1] || (_cache[1] = ($event: any) => ((_unref(generateImageData).canvas.height) = $event)),
              width: _unref(generateImageData).canvas.width,
              "onUpdate:width": _cache[2] || (_cache[2] = ($event: any) => ((_unref(generateImageData).canvas.width) = $event)),
              class: "sizes"
            }, null, 8, ["height", "width"]),
            _createVNode(_component_v_spacer),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(AiButton, {
                theme: "dark",
                onClick: _cache[3] || (_cache[3] = ($event: any) => {imageForActions.value = ''; _unref(generateImageData).products = []})
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('services.reset')), 1)
                ]),
                _: 1
              }),
              _createVNode(AiButton, {
                disabled: generationLoading.value,
                theme: "gradient-primary",
                onClick: generateBackgroundHandler
              }, {
                default: _withCtx(() => [
                  (!generationLoading.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('editor.settings.generate')), 1)
                      ], 64))
                    : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(AiCard, {
            radius: 16,
            class: "d-flex align-center tools__item"
          }, {
            default: _withCtx(() => [
              _createVNode(SizesList, {
                height: _unref(generateImageData).canvas.height,
                "onUpdate:height": _cache[4] || (_cache[4] = ($event: any) => ((_unref(generateImageData).canvas.height) = $event)),
                width: _unref(generateImageData).canvas.width,
                "onUpdate:width": _cache[5] || (_cache[5] = ($event: any) => ((_unref(generateImageData).canvas.width) = $event)),
                class: "sizes"
              }, null, 8, ["height", "width"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(AiButton, {
              theme: "dark",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (imageForActions.value = '')),
              style: {"width":"50%"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('services.reset')), 1)
              ]),
              _: 1
            }),
            _createVNode(AiButton, {
              disabled: generationLoading.value,
              theme: "gradient-primary",
              onClick: generateBackgroundHandler,
              style: {"width":"50%"}
            }, {
              default: _withCtx(() => [
                (!generationLoading.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('editor.settings.generate')), 1)
                    ], 64))
                  : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 64))
  ], 2))
}
}

})